import CLASS_RISK_RATING_LOOKUP from '../../../../config/simm/default/class_risk_rating_lookup.yml';
import dig from '../dig';

export default function calculateRiskRating(elementClass, conditionRating) {
  return dig(CLASS_RISK_RATING_LOOKUP, elementClass, conditionRating);
}
